import * as React from 'react';
import { appPowerPoint } from 'owa-locstrings/lib/strings/apppowerpoint.locstring.json';
import { appExcel } from 'owa-locstrings/lib/strings/appexcel.locstring.json';
import { appWord } from 'owa-locstrings/lib/strings/appword.locstring.json';
import loc from 'owa-localize';
import {
    WovenEditInDesktopPremiumUpsellPopupTitle,
    WovenEditInDesktopPremiumUpsellPopupDesc,
    WovenEditInDesktopPremiumUpsellPopupGoPremiumButtonText,
    WovenEditInDesktopPremiumUpsellPopupListItem1,
    WovenEditInDesktopPremiumUpsellPopupListItem2,
    WovenEditInDesktopPremiumUpsellPopupListItem3,
} from './WovenEditInDesktopPremiumUpsellPopup.locstring.json';
import { OfficeOnlineApp } from 'owa-file';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { assertNever } from 'owa-assert';

const APPLIST_SVG = require('../resources/Applist.svg');
const PREMIUM_LINK = 'https://go.microsoft.com/fwlink/?linkid=2139430&clcid=0x409';

export interface WovenEditInDesktopPremiumUpsellPopupProps {
    officeApp: OfficeOnlineApp;
}

export default async function showWovenEditInDesktopPremiumUpsellPopup(
    officeApp: OfficeOnlineApp,
    targetWindow?: Window
) {
    let appDisplayName: string = null;
    switch (officeApp) {
        case OfficeOnlineApp.Word:
            appDisplayName = appWord;
            break;
        case OfficeOnlineApp.Excel:
            appDisplayName = appExcel;
            break;
        case OfficeOnlineApp.PowerPoint:
            appDisplayName = appPowerPoint;
            break;
        default:
            assertNever(officeApp);
            break;
    }

    const response = await confirm(
        loc(WovenEditInDesktopPremiumUpsellPopupTitle, loc(appDisplayName)),
        null /* subText */,
        false /* resolveImmediately */,
        {
            targetWindow: targetWindow,
            hideCancelButton: true,
            okText: loc(WovenEditInDesktopPremiumUpsellPopupGoPremiumButtonText),
            dialogContentProps: { showCloseButton: true },
            bodyElement: (
                <>
                    <p>{loc(WovenEditInDesktopPremiumUpsellPopupDesc)}</p>
                    <ul>
                        <li>{loc(WovenEditInDesktopPremiumUpsellPopupListItem1)}</li>
                        <li>{loc(WovenEditInDesktopPremiumUpsellPopupListItem2)}</li>
                        <li>
                            {loc(WovenEditInDesktopPremiumUpsellPopupListItem3)}
                            <br />
                            <img src={APPLIST_SVG} role="presentation" />
                        </li>
                    </ul>
                </>
            ),
        }
    );

    if (response === DialogResponse.ok) {
        window.open(PREMIUM_LINK, '_blank');
    }
}
